import React from 'react';
import './OurExperienceText.scss';

export default function OurExperienceText() {
  return (
    <div className="mads-our-experience-text-container">
      <div className="our-experience-text-wrapper">
        <div className="our-experience-text text--first">
          With our extensive experience in custom healthcare app development,
          we create solutions that are truly in demand. Your clients will definitely engage with them regularly!
          We don’t just build applications for the sake of it. We design them with purpose and precision.
        </div>
        <div className="our-experience-text text--second">
          Our mission is to improve patient care. OS-System is a top healthcare app development company
          that will streamline your workflow, making your job not only easier but also more efficient.
        </div>
      </div>
    </div>
  );
}
